var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 24.4519C19.4272 24.4519 24.7998 19.0793 24.7998 12.4519C24.7998 5.82449 19.4272 0.451904 12.7998 0.451904C6.17239 0.451904 0.799805 5.82449 0.799805 12.4519C0.799805 19.0793 6.17239 24.4519 12.7998 24.4519Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58203 14.7996C7.58203 15.664 8.28281 16.3648 9.14723 16.3648H13.8429C13.8429 17.0851 14.4269 17.6691 15.1472 17.6691H16.7124C17.4328 17.6691 18.0168 17.0851 18.0168 16.3648V14.7996H7.58203Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.148 7.23438V10.8865C18.148 11.4619 17.6799 11.93 17.1045 11.93V13.4952C18.5429 13.4952 19.7132 12.325 19.7132 10.8865V7.23438H18.148Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9302 10.8865C6.9302 11.4619 6.46211 11.93 5.88672 11.93V13.4952C7.32517 13.4952 8.49541 12.325 8.49541 10.8865V7.23438H6.9302V10.8865Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 7.23438H17.365V10.8865H15.7998V7.23438Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4522 9.32134C13.4522 9.4652 13.3352 9.5822 13.1914 9.5822C13.0475 9.5822 12.9305 9.46516 12.9305 9.32134V7.23438H11.3653V9.32134C11.3653 9.4652 11.2482 9.5822 11.1044 9.5822C10.9606 9.5822 10.8436 9.46516 10.8436 9.32134V7.23438H9.27832V9.32134C9.27832 10.3283 10.0975 11.1475 11.1044 11.1475C11.4922 11.1475 11.8519 11.0256 12.1479 10.8186C12.4439 11.0255 12.8036 11.1475 13.1914 11.1475C13.2695 11.1475 13.3463 11.142 13.4218 11.1324C13.3109 11.5893 12.8993 11.93 12.4088 11.93V13.4952C13.8472 13.4952 15.0175 12.325 15.0175 10.8865V9.32134V7.23438H13.4523V9.32134H13.4522Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27832 11.9302H11.6261V13.4954H9.27832V11.9302Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/SaudiArabia.f572b6514b70c9508e990ecb16cda516.svg";
export { ForwardRef as ReactComponent };